export default __webpack_public_path__ + "static/propertysales-67872c61639adc2394859533a213a47c.png";